import { render, staticRenderFns } from "./TributeStoriesContribute.vue?vue&type=template&id=065ece75&scoped=true"
import script from "./TributeStoriesContribute.vue?vue&type=script&lang=js"
export * from "./TributeStoriesContribute.vue?vue&type=script&lang=js"
import style0 from "./TributeStoriesContribute.vue?vue&type=style&index=0&id=065ece75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ece75",
  null
  
)

export default component.exports